import { DidomiSDK } from '@didomi/react'
import isServerSide from '../../modules/is-server-side'
import { createContext, useContext, useState } from 'react'
import consoleLogger from '../../modules/console-logger'
import cmpWallPreparations from './modules/cmp-wall-preparations'

const setAdvertisingId = (didomi) => {
  if (!isServerSide() && window && window.device_native_advertising_identifier) {
    didomi.setUser({
      device: {
        advertising_id: window.device_native_advertising_identifier,
      },
    })
  }
}

const DidomiContext = createContext(null)

const DidomiProvider = ({ children }) => {
  const [didomi, setDidomi] = useState('loading')
  const [consoleLog] = consoleLogger('CMP')
  const showCMP = !isServerSide() && window.location.pathname !== '/p/geolocationwall'

  return (
    <DidomiContext.Provider value={didomi}>
      {showCMP && (
        <DidomiSDK
          apiKey="f2f6fb46-54b7-4fca-805b-b3a56cd4e6b2"
          noticeId="ZFfiLJ4H"
          onReady={(didomi) => {
            consoleLog('ready', didomi)
            setAdvertisingId(didomi)
            setDidomi(didomi)
          }}
          onNoticeShown={() => {
            consoleLog('notice shown')
            cmpWallPreparations()
          }}
        />
      )}
      {children}
    </DidomiContext.Provider>
  )
}

const useDidomiContext = () => {
  return useContext(DidomiContext)
}

export default DidomiProvider
export { useDidomiContext }
